// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "Header-module--wrapper--GfbQ8";
export var header = "Header-module--header--hNlU+";
export var logo = "Header-module--logo--lmRDU";
export var langSwitcher = "Header-module--langSwitcher--aOhSC";
export var navWrapper = "Header-module--navWrapper--JYsz7";
export var actionsWrapper = "Header-module--actionsWrapper--02qUz";
export var userMenu = "Header-module--userMenu--UI6DI";
export var mobileMenuActions = "Header-module--mobileMenuActions--O07+g";
export var mobileMenuTitle = "Header-module--mobileMenuTitle--MLLcU";
export var burger = "Header-module--burger--iUQC9";